import { configureStore } from '@reduxjs/toolkit';
import spinnerReducer from './slices/spinnerSlice';
import filtersReducer from './slices/filtersSlice';
import { dataReducer } from '../features/data';

const store = configureStore({
  reducer: {
    spinner: spinnerReducer,
    data: dataReducer,
    filters: filtersReducer,
  },
});

export default store;